export default __webpack_public_path__ + "static/media/hsc_meter_404.f06d3893.webp";